import { motion, AnimatePresence } from 'framer-motion';
import { useReducer } from 'react';
import { createPortal } from 'react-dom';

import Spinner from '@/components/Spinner';

import * as styles from '@/styles/components/Processing';

type Processing = {
  visible: boolean;
};

export const useProcessing = (initialState = false) => {
  const [processing, toggleProcessing] = useReducer((processing) => !processing, initialState);

  return [processing, toggleProcessing] as const;
};

const Processing = ({ visible }: Processing) => {
  if (typeof window === 'undefined') {
    return null;
  } else {
    return createPortal(
      <AnimatePresence>
        {visible && (
          <motion.div
            css={styles.root}
            key='processing'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}>
            <Spinner size='md' />
          </motion.div>
        )}
      </AnimatePresence>,
      document.body,
    );
  }
};

export default Processing;
